<!--
 * @Author: fengzhongmei
 * @Date: 2020-03-09 19:47:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-23 11:22:56
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div class="dash-pack">
        <!-- <div v-if="($route.query.authorityProjectId&&$route.query.authorityProjectId!=='all')||($store.state.user.currentUser.projectId&&$store.state.user.currentUser.projectId!=='all')">
            <projectDashboard></projectDashboard>
        </div> -->
        <div>
            <adminDashboard v-if="isAdmin"></adminDashboard>
            <individualDashboard v-else></individualDashboard>
            <!-- <updatePassword
                :userSid="this.$store.state.user.currentUser.info.userSid"
                ref="updatePasswordModal"
            ></updatePassword> -->
        </div>
    </div>
</template>

<script>
import adminDashboard from './admin/dashboard'
import individualDashboard from './individual/dashboard'
// import projectDashboard from '../accesscontrol/project/components/projectdashboard'
// import updatePassword from '@/views/console/user/components/updatepassword'

export default {
    name: 'dashboard',
    components: {
        adminDashboard,
        individualDashboard
        // projectDashboard
        // updatePassword
    },
    data () {
        return {
        }
    },
    computed: {
        isAdmin () {
            return this.$store.state.user.currentUser.isBssAdmin
        }
    },
    mounted () {
        // if (this.$store.state.user.currentUser.info.pwdEndTime && this.$store.state.user.currentUser.info.pwdEndTime !== null) {
        //     this.$Message.warning('密码已过期，请修改密码')
        //     this.$refs.updatePasswordModal.show = true
        // }
    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.dash-pack {
    background-color: #f5f6f7;
    min-height: 100%;
}
</style>
